import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux'

import { Card } from '../../../common/index';
import Masonry from 'react-masonry-component';

import classes from './JewelsCards.module.scss';

import { toggleFavorite } from '../../../redux/jewels/actions';



class JewelsCards extends Component {
   
    render() {
       
        return(
            <Masonry
            options={{
              gutter: 30
            }}>
            { this.props.jewels.map((jewelitem)=>{ return(
            <div  key={jewelitem.id} className={classes.Card} >
              <Card onClick={()=>this.props.history.push(`/jewels/${jewelitem.id}`)}  imagefull={jewelitem.image} withfavorite isfavorite={ this.props.favorites.find((element)=>{ return element === jewelitem.id; })}>
                <h2>{ jewelitem.surtitre }</h2>
                <h1>{ jewelitem.titre }</h1>
                <p>{ jewelitem.specs }</p>
              </Card>
              </div>
            )})}
            </Masonry>
        );
    }
}

const mapStateToProps = (state)=>{
    return {
      jewels: state.jewels.jewels,
      favorites: state.jewels.favorites
    }
  };

export default connect(mapStateToProps)(withRouter(JewelsCards));
